export default __webpack_public_path__ + "static/media/banner.9d49bc4d.png";